import {
  SET_JOBS,
  SET_JOB_DESCRIPTION
} from '@/store/mutation-types'
import service from '@/service'
import isEmpty from 'lodash/isEmpty'
import nbsp from '@/assets/js/nbsp'

const state = {
  jobs: [],
  description: {}
}

const getters = {
  jobs (state, getters, { i18n }) {
    const localizeJob = job => ({
      ...job,
      title: job.title[i18n.locale],
      description: job.description[i18n.locale],
      type: job.type[i18n.locale]
    })
    return state.jobs.map(localizeJob)
  },
  jobDescription (state, getters, { i18n }) {
    const localizeDescription = description => description[i18n.locale]
    return localizeDescription(state.description)
  }
}

const mutations = {
  [SET_JOBS] (state, jobs = []) {
    const createJob = job => ({
      title: {
        pl: job.name,
        en: job.name_en
      },
      description: {
        pl: nbsp(job.desc),
        en: nbsp(job.desc_en)
      },
      type: {
        pl: job.type,
        en: job.type_en
      },
      link: '#'
    })
    state.jobs = jobs.map(createJob)
  },
  [SET_JOB_DESCRIPTION] (state, description) {
    const createDescription = description => ({
      pl: nbsp(description.content),
      en: nbsp(description.content_en)
    })

    state.description = createDescription(description)
  }
}

const actions = {
  fetchJobs ({ state, commit }) {
    if (!isEmpty(state.jobs)) return Promise.resolve()

    return service.contact.jobs().then((res = {}) => {
      commit(SET_JOBS, res.jobs)
    })
  },
  fetchJobDescription ({ state, commit }) {
    if (!isEmpty(state.description)) return Promise.resolve()

    return service.contact.description().then((res = {}) => {
      commit(SET_JOB_DESCRIPTION, res.entry)
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contact.js